export const AuthenticationStore = {
  namespaced: true,
  state: {
    user: undefined,
    menuRights: undefined,
    isRememberMe: false,
    rememberedUsername: "",
    rememberedPassword: ""
  },
  actions: {
    async Login({ commit }, action) {
      commit("refreshUser", action.payload);
    },
    async initUser({ commit }, action) {
      commit("initUser", action.payload);
    },
    async ChangeHeaderIcon({ commit }, action) {
      commit("refreshHeaderIcon", action.payload);
    },
    async ChangeAccessRights({ commit }, action) {
      commit("refreshUserAccessRights", action.payload);
    },
    async RememberMe({ commit }, action) {
      commit("rememberMe", action.payload);
    },
    async setCandidatelLang({ commit }, action) {
      commit("setCandidatelLang", action.payload);
    },
  },
  getters: {
    lang: state => {
      return state.user ? state.user.Lang : "EN";
    },
    token: state => {
      return state.user.AccessToken ? state.user.AccessToken : "EN";
    },
    user: state => {
      return state.user ? state.user : undefined;
    },
    isRememberMe: state => {
      return state.isRememberMe;
    },
    rememberedUsername: state => {
      return state.rememberedUsername;
    },
    rememberedPassword: state => {
      return state.rememberedPassword;
    },
    candidatelLang: state => {
      return state.candidatelLang;
    },
  },
  mutations: {
    refreshUser(state, payload) {
      state.user = payload;
    },
    initUser(state, payload) {
      state.user = undefined;
    },
    setCandidatelLang(state, payload) {
      state.candidatelLang = payload;
    },
    refreshHeaderIcon(state, payload) {
      const originalUser = JSON.parse(JSON.stringify(state.user));
      originalUser.Lang = payload.Lang;
      originalUser.EngName = payload.EngName;
      originalUser.ChiName = payload.ChiName;
      originalUser.PhotoPath = payload.PhotoPath;
      originalUser.JobTitle = payload.JobTitle;
      state.user = originalUser;
    },
    refreshUserAccessRights(state, payload) {
      const originalUser = JSON.parse(JSON.stringify(state.user));
      originalUser.UserGrpRights = payload;
      state.user = originalUser;
    },
    rememberMe(state, payload) {
      state.isRememberMe = payload.isRememberMe;
      state.rememberedUsername = payload.isRememberMe ? payload.username : "";
      state.rememberedPassword = payload.isRememberMe ? payload.password : "";
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/global/AuthenticationStore/AuthenticationStore.js